module.exports = __webpack_public_path__ + "img/ENDODONCIA_REALIZADA.png";